import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import * as FullStory from '@fullstory/browser';
import * as Sentry from '@sentry/browser';
import { Event } from '@sentry/types';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  initSentry(): void {
    Sentry.init({
      dsn: environment.sentryDSN,
      denyUrls: [/localhost/],
      attachStacktrace: true,
      beforeSend: (event, hint): Event => {
        if (window.FS) {
          const error = hint.originalException;
          if (error != null) {
            if (typeof error === 'string') {
              window.FS.event('Application Error', { message: error, sentryEventId: hint.event_id });
            } else if (error instanceof Error) {
              window.FS.event('Application Error', {
                name: error.name,
                message: error.message,
                stack: error.stack,
                sentryEventId: hint.event_id,
              });
            }
          }
        }
        return event;
      },
    });
  }

  initFullStory(): void {
    FullStory.init({
      orgId: '9ZEQS',
      devMode: !environment.production,
    });
  }
}
